// src/components/settings/clientRegisterFilter.js
//
// The Client Register's filter row (Settings): Tier and/or Company Name,
// combined with AND, client-side only — it narrows the rows already loaded and
// changes no data. React-free so it is testable without MspOsApp (which pulls
// MSAL in at module load).
//
// ⚠ The Tier filter matches the DISPLAYED tier: `c._tier` is the merged value
// the backend's tierFor() hands back (manual override over the derived one),
// and the register patches it in place when Craig picks a value — so a row
// just set to Gold matches "Gold" at once, not the stale derived tier. An
// absent tier displays as Adhoc, and filters as Adhoc.

export const TIER_FILTER_ALL = "";

/** The tier a register row SHOWS — the same fallback the row itself uses. */
export const displayTierOf = (c) => (c && c._tier) || "Adhoc";

/** Case-insensitive substring match on the company name; blank matches everything. */
export const matchesName = (c, needle) => {
  const n = String(needle || "").trim().toLowerCase();
  if (!n) return true;
  return String((c && c.companyName) || "").toLowerCase().includes(n);
};

/**
 * @param companies  the register's rows (atCompanies)
 * @param filter     { tier: "" | "Gold" | …, name: "" | text }
 * @returns the rows to display, in the original order
 */
export function filterRegisterRows(companies, { tier = TIER_FILTER_ALL, name = "" } = {}) {
  const t = String(tier || "");
  return (companies || []).filter((c) => c && (!t || displayTierOf(c) === t) && matchesName(c, name));
}

export const isRegisterFilterActive = ({ tier = TIER_FILTER_ALL, name = "" } = {}) =>
  !!String(tier || "") || !!String(name || "").trim();
